import React from "react";
import { Radio, VStack } from "@chakra-ui/react";
import { AccordionItem, Form, RadioGroup } from "components";
import { TemperatureUnitEnum } from "requests";
import { OrganizationSetting } from "../../../../duck";
import { FormValues, useUpdateTemperatureUnit } from "./duck";

interface TemperatureProps {
  settings: OrganizationSetting;
}

const Temperature: React.FC<TemperatureProps> = ({ settings }) => {
  const handleSubmit = useUpdateTemperatureUnit(settings._id);

  return (
    <AccordionItem title="Temperature Unit">
      <Form<FormValues>
        defaultValues={{ temperatureUnit: settings.temperatureUnit }}
      >
        <Form.Watcher
          defaultValues={{ temperatureUnit: settings.temperatureUnit }}
          onChange={handleSubmit}
        />
        <RadioGroup label="Temperature Unit" name="temperatureUnit">
          <VStack alignItems="left">
            <Radio value={TemperatureUnitEnum.Fahrenheit}>Fahrenheit</Radio>
            <Radio value={TemperatureUnitEnum.Celsius}>Celsius</Radio>
          </VStack>
        </RadioGroup>
      </Form>
    </AccordionItem>
  );
};

export default Temperature;
